import { MessageCenter } from "message/components/MessageCenter"
import React from "react"
import { HEADER_PHONE_HEIGHT_IN_REM, MAIN_LAYOUT_ID } from "ui/model"
import { FlexBox } from "../FlexBox"
import { Routes } from "../router/Routes"
import { HeaderPhone } from "./HeaderPhone"
import { MenuPhone } from "./MenuPhone"

export const MainLayoutPhone = (): JSX.Element => (
  <FlexBox
    id={MAIN_LAYOUT_ID}
    vertical
    fullHeight
    sx={{
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      flexWrap: "nowrap",
      backgroundColor: theme => theme.palette.background.default
    }}>
    <HeaderPhone />
    <MenuPhone />
    <FlexBox
      fullHeight={HEADER_PHONE_HEIGHT_IN_REM}
      sx={{
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%"
      }}
      className="route-container">
      <Routes />
    </FlexBox>
    <MessageCenter />
  </FlexBox>
)
